import { render, staticRenderFns } from "./Predmeti.vue?vue&type=template&id=17eb0b98&scoped=true&"
import script from "./Predmeti.vue?vue&type=script&lang=js&"
export * from "./Predmeti.vue?vue&type=script&lang=js&"
import style0 from "./Predmeti.vue?vue&type=style&index=0&id=17eb0b98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17eb0b98",
  null
  
)

export default component.exports